/**
 * @see mockMd/union_city_war_score_record.md
 */
import type {UnionCityWarScoreRecordData} from '../types'
import {storiesGiftIcon} from '../components/PkRecordDrawer/stories-images'

const pkDay = (
  date: string,
  city_score: number,
  pk_win_cnt: number
): UnionCityWarScoreRecordData['day_list'][number] => ({
  date,
  city_score,
  normal_city_score: 0,
  exclusive_city_score: 0,
  sign_anchor_cnt: 0,
  gift_task_anchor_cnt: 0,
  sign_city_score: 0,
  gift_task_city_score: 0,
  pk_win_cnt,
})

const pkBox = (
  time: string,
  has_show_effect: boolean
): UnionCityWarScoreRecordData['box_rewards'][number] => ({
  time,
  reward: {
    id: 10002,
    activity_id: 123456,
    origin_name: 'PK Box',
    view_icon: storiesGiftIcon,
    toast_name: 'PK Box*1',
    reward_type: 1,
    reward_string: 'Avatar Frame',
    reward_quantity: 1,
    reward_tag: 'pk_box',
    reward_value: 100,
    has_show_effect,
  },
})

/** 财富殿堂获得记录 · 对齐 state-default 3 天 / 50000000 / +500000 */
export const UnionCityWarScoreRecordGiftMock: UnionCityWarScoreRecordData = {
  err_msg: '',
  total_city_score: 50000000,
  day_list: [
    {
      date: '2026.08.14',
      city_score: 1000000,
      normal_city_score: 500000,
      exclusive_city_score: 500000,
      sign_anchor_cnt: 0,
      gift_task_anchor_cnt: 0,
      sign_city_score: 0,
      gift_task_city_score: 0,
      pk_win_cnt: 0,
    },
    {
      date: '2026.07.30',
      city_score: 1000000,
      normal_city_score: 500000,
      exclusive_city_score: 500000,
      sign_anchor_cnt: 0,
      gift_task_anchor_cnt: 0,
      sign_city_score: 0,
      gift_task_city_score: 0,
      pk_win_cnt: 0,
    },
    {
      date: '2026.07.17',
      city_score: 1000000,
      normal_city_score: 500000,
      exclusive_city_score: 500000,
      sign_anchor_cnt: 0,
      gift_task_anchor_cnt: 0,
      sign_city_score: 0,
      gift_task_city_score: 0,
      pk_win_cnt: 0,
    },
  ],
  box_rewards: [],
}

/** 守望塔任务记录 · 对齐稿面 3 天 / 50000000 / 行 +500000 */
export const UnionCityWarScoreRecordTaskMock: UnionCityWarScoreRecordData = {
  err_msg: '',
  total_city_score: 50000000,
  day_list: [
    {
      date: '2026.08.14',
      city_score: 1000000,
      normal_city_score: 0,
      exclusive_city_score: 0,
      sign_anchor_cnt: 5,
      gift_task_anchor_cnt: 3,
      sign_city_score: 500000,
      gift_task_city_score: 500000,
      pk_win_cnt: 0,
    },
    {
      date: '2026.07.30',
      city_score: 1000000,
      normal_city_score: 0,
      exclusive_city_score: 0,
      sign_anchor_cnt: 5,
      gift_task_anchor_cnt: 3,
      sign_city_score: 500000,
      gift_task_city_score: 500000,
      pk_win_cnt: 0,
    },
    {
      date: '2026.07.17',
      city_score: 1000000,
      normal_city_score: 0,
      exclusive_city_score: 0,
      sign_anchor_cnt: 5,
      gift_task_anchor_cnt: 3,
      sign_city_score: 500000,
      gift_task_city_score: 500000,
      pk_win_cnt: 0,
    },
  ],
  box_rewards: [],
}

/** PK 获得记录 · 对齐城建值 Tab 4 天 / 50000000 / +500000；宝箱 Tab 5 条 */
export const UnionCityWarScoreRecordPkMock: UnionCityWarScoreRecordData = {
  err_msg: '',
  total_city_score: 50000000,
  day_list: [
    pkDay('2026.08.14', 500000, 2),
    pkDay('2026.07.30', 500000, 2),
    pkDay('2026.07.17', 500000, 2),
    pkDay('2026.07.10', 500000, 2),
  ],
  box_rewards: [
    pkBox('2026-08-10 21:05:00', true),
    pkBox('2026-07-30 21:05:00', false),
    pkBox('2026-07-17 21:05:00', false),
    pkBox('2026-07-10 21:05:00', false),
    pkBox('2026-07-03 21:05:00', false),
  ],
}

export const UnionCityWarScoreRecordMock = UnionCityWarScoreRecordGiftMock
